import { FC, Key, PropsWithChildren, useEffect, useMemo, useRef, useState } from 'react';

type RemountOnKeyProps = {
    mountKey: Key;
};

export const RemountOnKey: FC<PropsWithChildren<RemountOnKeyProps>> = ({ mountKey, children }) => {
    const [phase, setPhase] = useState<'stable' | 'unmounting'>('stable');

    const lastKeyRef = useRef(mountKey);

    useMemo(() => {
        if (lastKeyRef.current !== mountKey) {
            lastKeyRef.current = mountKey;

            setPhase('unmounting');
        }
    }, [mountKey]);

    useEffect(() => {
        if (phase === 'unmounting') {
            setPhase('stable');
        }
    }, [phase]);

    if (phase === 'unmounting') {
        return null;
    }

    return children;
};
